<template>
	<v-container fluid class="fill-height">
		<v-row align="center" justify="center">
			<v-col cols="12" sm="8" md="6">
				<v-card class="elevation-12">
					<v-card-title class="display-1 blue darken-2 white--text">
						Sitio Fuera de Servicio
						</v-card-title>
					<v-card-text>
						<v-row align="center" justify="center">
							<v-col cols="12" sm="4" class="text-center">
								<v-icon size="100" color="blue darken-2">fas fa-tools</v-icon>
							</v-col>
							<v-col cols="12" sm="8">
								<p class="text-center">En este momento el sitio <strong>{{this.sitio}}</strong> no se encuentra disponible para ser usado, si usted es el administrador del mismo por favor contacte <a :href="href" class="blue--text">losandescoworking@gmail.com</a> o por el numero de teléfono <strong>0424-2192367</strong>  o po nuestro chat integrado.</p>
								<p class="text-center body-1">Lamentamos las molestias ocasionadas y le invitamos a ingresar nuevamente mas tarde.</p>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	export default {
		name: 'ofa',
		created(){
			let cual = this.$route.params.num
			this.sitio = this.$sitios[cual-1]
		},
		data () {
			return {
				sitio:null,
			}
		},
		computed: {
			href: function () {
				let string = 'mailto:losandescoworking@gmail.com?subject='

				let encondeSubject = encodeURI('[Tech] Sitio '+this.sitio+ ' Fuera de servicio')

				return string+encondeSubject
			}
		}
	}
</script>